import { DataGrid, GridToolbarContainer } from "@mui/x-data-grid";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { BankExchangeRateAPI, downloadExchangeRate } from "../../Services/api";
import instance from "../../redux/api";
import { CommonButton } from "../common/commonButton";
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Grid,
  IconButton,
  Stack,
  TableContainer,
  TextField,
  Tooltip,
  Box,
  Typography,
} from "@mui/material";
import { ViewAndEditEntity } from "./ViewAndEditEntity";
import CloseIcon from "@mui/icons-material/Close";
import AddIcon from "@mui/icons-material/Add";
import DeleteIcon from "@mui/icons-material/DeleteOutlined";
import VisibilityIcon from "@mui/icons-material/Visibility";
import EditNoteIcon from "@mui/icons-material/EditNote";
import FilterListIcon from "@mui/icons-material/FilterList";
import { AddBankExchange } from "./AddBankExchange";
import format from "date-fns/format";
import { useStyles } from "../bankTransactions/bankTranscationContainerStyles";
import { CommonFilterSidebar, CommonSelect, CommonPaginationContainer } from "../common";
import { getCurrencyList } from "../../redux/slice/bankStatmentTransactionsSlice";
import { getPaginationCount } from "../CashAllocation/utils";
import { commonToast } from "../common";
import "../common/commonPageStyles.css";
// import { numberFormatter } from "../../utils/generalFunctions";

export const numberFormatter = (value) =>
  new Intl.NumberFormat("en-US", {
    // These options are needed to round to whole numbers if that's what you want.
    minimumFractionDigits: 7, // (this suffices for whole numbers, but will print 2500.10 as $2,500.1)
    maximumFractionDigits: 7, // (causes 2500.99 to be printed as $2,501)
  }).format(value);

//styles

const AssignBankStatementBar = {
  display: "flex",
  justifyContent: "space-between",
  height: 32,
  fontWeight: "400",
  marginTop: 10,
};
const editEntityUpdate = {
  width: "90px",
  padding: "18px 0px",
  borderRadius: "20px",
  gap: "8px",
}

const bankTransactionAddBtn = {
  backgroundColor: "#1672DE",
  color: "white",
  borderRadius: "10px",
  padding: "10px 24px",
  fontWeight: "600",
  fontSize: "14px",
  textTransform: "none",
  minHeight: "40px",
  minWidth: "120px",
  boxShadow: "0 2px 8px rgba(22, 114, 222, 0.2)",
  transition: "all 0.3s cubic-bezier(0.4, 0, 0.2, 1)",
  "&:hover": {
    backgroundColor: "#1565c0",
    boxShadow: "0 4px 12px rgba(22, 114, 222, 0.3)",
    transform: "translateY(-1px)",
  },
};

const downloadBtn = {
  backgroundColor: "#1672DE",
  color: "white",
  borderRadius: "10px",
  padding: "10px 24px",
  fontWeight: "600",
  fontSize: "14px",
  textTransform: "none",
  minHeight: "40px",
  minWidth: "120px",
  boxShadow: "0 2px 8px rgba(22, 114, 222, 0.2)",
  transition: "all 0.3s cubic-bezier(0.4, 0, 0.2, 1)",
  "&:hover": {
    backgroundColor: "#1565c0",
    boxShadow: "0 4px 12px rgba(22, 114, 222, 0.3)",
    transform: "translateY(-1px)",
  },
};

const EditPageContainerTransactions = {
  padding: "10px",
  cursor: "default",
  width: "100%",
  marginLeft: "-10px",
};

const EditPageContainerTransactionsList = {
  display: "flex",
  justifyContent: "end",
  width: "100%",
  alignItems: "center",
  marginBottom: "10px"
};


const months = { "January": "01", "February": "02", "March": "03", "April": "04", "May": "05", "June": "06", "July": "07", "August": "08", "September": "09", "October": "10", "November": "11", "December": "12" };

export default function BankExchangeRate() {
  // Selectors
  const toggle = useSelector((state) => state.toggleSideMenu);
  const { userData } = useSelector((state) => state?.user);
  const dropdownValuesCurreny = useSelector(
    (state) => state?.bankStatmentTransactions?.currencyList
  ) || [];

  //Local state
  const [rows, setRows] = useState([{ month: "", currency_code: "", exchange_rate: "" }]);
  // const [tableRows, setTableRows] = useState([]);
  // const [isApiCallInprogress, setIsApiCallInprogress] = useState(false);
  // const [searchText, setSearchText] = useState("");
  const [EntityDialog, setEntityDialog] = useState(false);
  const [editRow, setEditRow] = useState("");
  const [viewMode, setViewMode] = useState(false);
  const [editMode, setEditMode] = useState(false);
  const [isCreated, setIsCreated] = useState(true);
  const [editId, setEditId] = useState("");
  // const [pageSize, setPageSize] = useState(5);
  // const [page, setPage] = useState(0);
  const [currentUpdatedFiledsInEditMode, setCurrentUpdatedFiledsInEditMode] =
    useState({});
  const [validationStatus, setValidationStatus] = useState(
    Array(rows.length).fill(true)
  );
  // const [isButtonDisabled, setIsButtonDisabled] = useState(false);
  const [selectAll, setSelectAll] = useState(false);
  const [selectedRows, setSelectedRows] = useState([]);
  // const [isFileUploadDialogOpen, setIsFileUploadDialogOpen] = useState(false);
  // const [uploadedFiles, setUploadedFiles] = useState([]);
  const classes = useStyles();
  const [searchFieldPrams, setSearchFieldPrams] = useState({
    Currency_Code: "",
    Transaction_Month: "",
    Transaction_Year: ""
  })
  const [isSearchPerformed, setIsSearchPerformed] = useState(false);
  const [isClearPerformed, setIsClearPerformed] = useState(false);
  const [filterSidebarOpen, setFilterSidebarOpen] = useState(true);
  const dispatch = useDispatch();

  useEffect(() => {
    // Fetch Currency Details
    dispatch(getCurrencyList());
  }, []);

  //For pagination
  const [paginationCount, setPaginationCount] = useState(0);
  const [pageState, setPageState] = useState({
    isLoading: true,
    data: [],
    total: 0,
    page: 1,
    pageSize: 25,
  });
  const [isDownloadInProgress, setIsDownloadInProgress] = useState(false);

  // skip 0 means page 1
  const currentSkipNumber = () => {
    return pageState?.page === 1
      ? 0
      : pageState?.page === 0
        ? pageState?.page
        : pageState?.page - 1;
  };

  useEffect(() => {
    setPaginationCount(getPaginationCount(pageState?.total, pageState?.pageSize));
  }, [pageState.total, pageState.pageSize]);

  useEffect(() => {
    if (!isClearPerformed) {
      loadData();
    }
  }, [pageState?.pageSize, pageState?.page]);

  useEffect(() => {
    if (isClearPerformed) {
      loadData();
      setIsClearPerformed(false);
    }
  }, [isClearPerformed]);

  useEffect(() => {
    if (selectAll) {
      const updatedSelectedRows = [...selectedRows];
      updatedSelectedRows.fill(selectAll);
      setSelectedRows(updatedSelectedRows);
    }
  }, [selectAll]);

  useEffect(() => {
    const selectedRowCount = selectedRows.filter(Boolean).length;
    if (selectedRowCount < rows.length) {
      setSelectAll(false);
    }
  }, [rows, selectedRows]);

  const loadData = async () => {
    try {
      setPageState((old) => ({
        ...old,
        isLoading: true,
      }));
      let queryParams = `skip=${currentSkipNumber()}&pageSize=${pageState?.pageSize}`;

      if (isSearchPerformed) {
        const { Currency_Code, Transaction_Month, Transaction_Year } = searchFieldPrams;

        if (Currency_Code) {
          queryParams = `${queryParams}&currencyCode=${Currency_Code}`;
        }
        if (Transaction_Month) {
          queryParams = `${queryParams}&transactionMonth=${Transaction_Month}`;
        }
        if (Transaction_Year) {
          queryParams = `${queryParams}&transactionYear=${Transaction_Year}`;
        }
      }
      const response = await instance.get(
        `${BankExchangeRateAPI}?${queryParams
        }`
      );
      setPageState((old) => ({
        ...old,
        isLoading: false,
      }));

      if (response.status === 200) {
        setPageState((old) => ({
          ...old,
          total: response?.data?.count,
          data: response?.data?.data ?? [],
        }));
        setPaginationCount(
          getPaginationCount(response?.data?.count, pageState?.pageSize)
        );
      } else {
        setPageState((old) => ({
          ...old,
          total: response?.data?.count,
          data: [],
        }));
        setPaginationCount(0);
      }
    } catch (err) {
      setPageState((old) => ({
        ...old,
        isLoading: false,
      }));
      setPaginationCount(0);
      console.error("err", err);
    }
  };

  const Container = {
    width: "100%",
    display: "flex",
    flexDirection: "row",
    gap: 0,
    height: "calc(100vh - 180px)",
    maxHeight: "calc(100vh - 180px)",
    overflow: "hidden",
    position: "relative",
  };

  const handleDialogClose = () => {
    setEntityDialog(false);
    setEditMode(false)
    setViewMode(false)
    if (!editMode && !viewMode) {
      setRows([
        {
          month: "",
          currency_code: "",
          exchange_rate: ""
        }
      ]);
      setSelectedRows([false]);
      setValidationStatus([true]);
    }
    else if (editMode) {
      setValidationStatus([true]);
      setCurrentUpdatedFiledsInEditMode({});
    }

  };


  const handleCurrencyDropDown = (name, value, reason) => {
    setSearchFieldPrams({
      ...searchFieldPrams,
      [name]: value ?? ""
    })
    if (reason === "clear") {
      /*
      loadData();
      setSearchFieldPrams({
        ...searchFieldPrams,
        Transaction_Month: "",
        Currency_Code: "",
        Transaction_Year: ""
      })
      */
      handleClearSearchList();
    }
  }


  const handleTextFieldchange = (name, value) => {
    setSearchFieldPrams({
      ...searchFieldPrams,
      [name]: value ?? ""
    });
    if (isSearchPerformed && !value) {
      const searchFields = searchFieldPrams;
      delete searchFields[name];
      if (Object.values(searchFields).every(value => !value)) {
        handleClearSearchList();
      }
    }
  };


  const isFilterBtnDisable = () => {
    let disabled = true;
    const { Currency_Code, Transaction_Month, Transaction_Year } = searchFieldPrams;
    if (Currency_Code !== "" || Transaction_Month !== "" || Transaction_Year !== "") {
      disabled = false;
    }
    return disabled;
  }


  const handleSearchBnkExchangeList = async () => {
    try {
      let queryParams = `?skip=0&pageSize=${pageState?.pageSize}`;

      const { Currency_Code, Transaction_Month, Transaction_Year } = searchFieldPrams;
      if (Currency_Code) {
        queryParams = `${queryParams}&currencyCode=${Currency_Code}`;
      }

      // let formattedFromDateValue = "";

      if (Transaction_Year) {
        queryParams = `${queryParams}&transactionYear=${Transaction_Year}`;
      }
      if (Transaction_Month) {
        // formattedFromDateValue = format(Transaction_Month, "dd/MM/yyyy");
        // queryParams = `${queryParams}&dateReceived=${formattedFromDateValue}`;
        queryParams = `${queryParams}&transactionMonth=${Transaction_Month}`
      }

      setPageState((old) => ({
        ...old,
        isLoading: true
      }));

      const response = await instance.get(`${BankExchangeRateAPI}${queryParams}`);

      setPageState((old) => ({
        ...old,
        isLoading: false,
      }));

      if (response.status === 200) {
        console.log("broker", response)
        setPageState((old) => ({
          ...old,
          total: response?.data?.count,
          data: response?.data?.data ? response?.data?.data : [],
          page: 1
        }));
        setIsSearchPerformed(true);
        setPaginationCount(getPaginationCount(response?.data?.count, pageState?.pageSize));
      } else {
        setPageState((old) => ({
          ...old,
          total: response?.data?.count ?? 0,
          data: [],
        }));
        setPaginationCount(0);
      }

    } catch (err) {
      setPageState((old) => ({
        ...old,
        isLoading: true
      }));
      console.log("err", err);
    }
  };


  const handleClearSearchList = () => {
    // loadData();
    setIsSearchPerformed(false);
    setSearchFieldPrams({
      ...searchFieldPrams,
      Currency_Code: "",
      Transaction_Month: "",
      Transaction_Year: ""
    })
    setPageState((old) => ({
      ...old,
      page: 1
    }));
    setIsClearPerformed(true);
  }

  const handleApplyFilters = () => {
    handleSearchBnkExchangeList();
  };

  const handleClearFilters = () => {
    handleClearSearchList();
  };



  // const handleSearch = (e) => {
  //   const value = e.target.value;
  //   setSearchText(value);
  //   let filteredData;
  //   if (value.trim() === '') {
  //     loadData();
  //     filteredData = tableRows;
  //   } else {
  //     filteredData = tableRows.filter((row) =>
  //       columns.some((column) => {
  //         const cellValue = row[column.field];
  //         if (Array.isArray(cellValue)) {
  //           // Check if the array is not null
  //           if (cellValue !== null && cellValue !== undefined) {
  //             // Check if any property within the objects in the array includes the search value
  //             return cellValue.some((item) =>
  //               Object.values(item).some(
  //                 (propValue) =>
  //                   propValue !== undefined &&
  //                   propValue !== null &&
  //                   propValue.toString().includes(value)
  //               )
  //             );
  //           }
  //         } else if (cellValue !== undefined && cellValue !== null) {
  //           // For non-array fields, continue with the existing logic
  //           return cellValue.toString().includes(value);
  //         }
  //         return false;
  //       })
  //     );
  //   }
  //   setTableRows(filteredData);
  // };

  // const handleFileUploadDialog = () => {
  //   setIsFileUploadDialogOpen(true);
  // };
  const handleCheckboxChange = (index, isChecked) => {
    const updatedSelectedRows = [...selectedRows];
    updatedSelectedRows[index] = isChecked;

    // Check the number of selected rows
    const selectedRowCount = updatedSelectedRows.filter(Boolean).length;

    setSelectedRows(updatedSelectedRows);
    setSelectAll(selectedRowCount === rows.length);
  };

  const handleActionButton = (rowData, isEditMode) => {
    const emptyRows = Array.from({ length: rows.length }, () => ({ month: "", currency_code: "", exchange_rate: "" }));
    if (rowData && isEditMode) {
      // Pre-fill the empty row with data for editing
      setRows([{ ...rowData }]);
      setEditRow(rowData);
      setEditMode(true);
      setEditId(rowData.id);
      setIsCreated(false);
    } else if (rowData && !isEditMode) {
      setRows([rowData]);
      setViewMode(true);
    } else {
      // If no rowDataForEdit is provided, it means we are in add mode
      setRows(emptyRows);
      setIsCreated(true);
      setEntityDialog(true);
    }
    setEntityDialog(true);
    if (rowData) {
      setIsCreated(false);
    } else {
      setIsCreated(true);
    }
  };

  const columns = [
    { field: "id", headerName: "ID", flex: 0.3, headerAlign: "center" },
    {
      field: "year",
      headerName: "Transaction Year",
      flex: 0.8,
      headerAlign: "center",
      valueGetter: (params) => {
        // Check if params.value is a valid date
        const dateValue = new Date(params?.row?.month);
        if (!isNaN(dateValue.getTime())) {
          // If it's a valid date, format it
          return format(dateValue, "yyyy");
        } else {
          // If it's not a valid date, return null
          return "";
        }
      },
    },
    {
      field: "month",
      headerName: "Transaction Month",
      flex: 0.8,
      headerAlign: "center",
      valueGetter: (params) => {
        // Check if params.value is a valid date
        const dateValue = new Date(params.value);
        if (!isNaN(dateValue.getTime())) {
          // If it's a valid date, format it
          return format(dateValue, "MMMM");
        } else {
          // If it's not a valid date, return null
          return "";
        }
      },
    },
    {
      field: "currency_code",
      headerName: "Currency Code",
      flex: 1,
      headerAlign: "center",
    },
    {
      field: "exchange_rate",
      headerName: "Exchange Rate",
      flex: 1,
      headerAlign: "center",
      renderCell: (params) => <>{numberFormatter(params?.row?.exchange_rate) ?? ""}</>,
      cellClassName: "amount-table-cell"
    },
    {
      field: "created_by",
      headerName: "Created By",
      flex: 1,
      headerAlign: "center",
      valueGetter: (params) => params?.value ?? "-"
    },
    {
      field: "updated_by",
      headerName: "Last Modified By",
      flex: 1,
      headerAlign: "center",
      valueGetter: (params) => params?.value ?? "-"
    },
    ...(userData?.role !== "CC Processor" ? [{
      field: "actions",
      headerName: "Actions",
      headerAlign: "center",
      flex: 0.8,
      renderCell: (params) => {
        return (
          <Box sx={{ display: "flex", alignItems: "center", gap: "8px" }}>
            {UserAuthorisation?.['View'] === "Y" && (
              <Tooltip title="View">
                <IconButton
                  onClick={() => handleActionButton(params.row, false)}
                  sx={{
                    backgroundColor: "rgba(22, 114, 222, 0.1)",
                    color: "#1672DE",
                    border: "1px solid #1672DE",
                    borderRadius: "8px",
                    padding: "6px",
                    width: "32px",
                    height: "32px",
                    transition: "all 0.3s ease",
                    "&:hover": {
                      backgroundColor: "rgba(22, 114, 222, 0.2)",
                      transform: "translateY(-2px)",
                      boxShadow: "0 4px 8px rgba(22, 114, 222, 0.2)",
                    },
                  }}
                >
                  <VisibilityIcon sx={{ fontSize: "16px" }} />
                </IconButton>
              </Tooltip>
            )}
            {UserAuthorisation?.['Edit'] === "Y" && (
              <Tooltip title="Edit">
                <IconButton
                  onClick={() => handleActionButton(params.row, true)}
                  sx={{
                    backgroundColor: "rgba(22, 114, 222, 0.1)",
                    color: "#1672DE",
                    border: "1px solid #1672DE",
                    borderRadius: "8px",
                    padding: "6px",
                    width: "32px",
                    height: "32px",
                    transition: "all 0.3s ease",
                    "&:hover": {
                      backgroundColor: "rgba(22, 114, 222, 0.2)",
                      transform: "translateY(-2px)",
                      boxShadow: "0 4px 8px rgba(22, 114, 222, 0.2)",
                    },
                  }}
                >
                  <EditNoteIcon sx={{ fontSize: "16px" }} />
                </IconButton>
              </Tooltip>
            )}
          </Box>
        );
      },
    }] : [
      {
        field: "actions",
        headerName: "Actions",
        headerAlign: "center",
        flex: 0.8,
        renderCell: (params) => {
          return (
            <Box sx={{ display: "flex", alignItems: "center", gap: "8px" }}>
              <Tooltip title="View">
                <IconButton
                  onClick={() => handleActionButton(params.row, false)}
                  sx={{
                    backgroundColor: "rgba(22, 114, 222, 0.1)",
                    color: "#1672DE",
                    border: "1px solid #1672DE",
                    borderRadius: "8px",
                    padding: "6px",
                    width: "32px",
                    height: "32px",
                    transition: "all 0.3s ease",
                    "&:hover": {
                      backgroundColor: "rgba(22, 114, 222, 0.2)",
                      transform: "translateY(-2px)",
                      boxShadow: "0 4px 8px rgba(22, 114, 222, 0.2)",
                    },
                  }}
                >
                  <VisibilityIcon sx={{ fontSize: "16px" }} />
                </IconButton>
              </Tooltip>
            </Box>
          );
        },
      }
    ]),
  ];
  // const loadData = async () => {
  //   try {
  //     setIsApiCallInprogress(true);
  //     const resp = await instance.get(BankExchangeRateAPI);
  //     setIsApiCallInprogress(false);
  //     if (resp.status === 200) {
  //       const sortedData = resp.data.sort((a, b) => b.id - a.id);
  //       setTableRows(sortedData);
  //     } else {
  //       setTableRows([]);
  //     }
  //   } catch (err) {
  //     setIsApiCallInprogress(false);
  //     console.error("err", err);
  //   }
  // };
  const UserAuthorisation =
    userData?.user_permissions?.permissions_list['Admin Table Maintenance'];

  // useEffect(() => {
  //   loadData();
  // }, []);

  const handleInputChange = (index, colName, value) => {
    const updatedRows = [...rows];
    if (updatedRows[index]) {
      if (colName === "exchange_rate") {
        updatedRows[index][colName] = Number(value);
      } else {
        updatedRows[index][colName] = value;
      }
      setRows(updatedRows);
      // Edit Mode
      if (editMode) {
        setCurrentUpdatedFiledsInEditMode({
          ...currentUpdatedFiledsInEditMode,
          [colName]: value,
        });
      }
    } else {
      console.error("Row at index", index, "is undefined.");
    }
  };
  const handleSelectAll = (e) => {
    const isChecked = e.target.checked;
    const updatedSelectedRows = new Array(rows.length).fill(isChecked);

    setSelectedRows(updatedSelectedRows);
    setSelectAll(isChecked);
  };

  const handleAddRow = () => {
    setRows([...rows, { month: "", currency_code: "", exchange_rate: "" }]);
  };
  const handleDeleteRow = () => {
    // Ensure there is at least one row remaining
    if (rows.length <= 1 || selectAll) {
      // Throw an error or show a message indicating that at least one row should remain
      commonToast("error", "At least One Row Should Remain!!");
      return;
    }

    const updatedRows = rows.filter((row, index) => !selectedRows[index]);
    setRows(updatedRows);

    // Clear selected rows and set Select All to false after deletion
    setSelectedRows([]);
    setSelectAll(false);
  };

  const validateRow = (index) => {
    const row = rows[index];
    const fieldValidations = {};

    // Perform your validations here, for example:
    if (!row || !row.month || row.month.trim() === "") {
      fieldValidations.month = "This field is required";
    }
    if (!row || !row.currency_code || row.currency_code.trim() === "") {
      fieldValidations.currency_code = "This field is required";
    }
    if (!row || !row.exchange_rate || !row.exchange_rate) {
      fieldValidations.exchange_rate = "This field is required";
    }

    // Add more validations for other fields...
    setValidationStatus((prevStatus) => {
      const newStatus = [...prevStatus];
      newStatus[index] = fieldValidations;
      return newStatus;
    });

    return Object.keys(fieldValidations).length === 0;
  };

  const handleSubmit = async () => {
    // Validate each row before submission
    const areRowsValid = rows
      .map((_, index) => validateRow(index))
      .every((value) => value);

    let editModeObj = {};
    if (!editMode) {
      // Add Mode
      // editModeObj.id = editRow?.id;
      // editModeObj["created_by"] = userData?.user_name ?? "";
      // editModeObj = { ...editModeObj, ...currentUpdatedFiledsInEditMode };
    } else {
      editModeObj.id = editRow?.id;
      editModeObj["updated_by"] = userData?.user_name ?? "";
      editModeObj = { ...editModeObj, ...currentUpdatedFiledsInEditMode };
    }

    if (!areRowsValid) {
      // If any row is invalid, stop the submission and display an error
      commonToast("error", "Please fix validation errors before submitting.");
      return;
    }

    try {
      let response;
      if (editMode) {
        response = await instance.patch(
          BankExchangeRateAPI + editId + "/",
          editModeObj
        );
        // clear preiously updated stored data
        setCurrentUpdatedFiledsInEditMode({});
      } else {
        let updatedRows = [...rows];
        for (let i = 0; i < updatedRows?.length; i++) {
          updatedRows[i].created_by = userData?.user_name;
        }
        response = await instance.post(BankExchangeRateAPI, updatedRows);
      }

      if (response) {
        if (editMode) {
          commonToast("success", "Updated successfully !");
        } else {
          commonToast("success", "Submission successful !");
        }

        // clean up
        cleanupTransactionData();
      }
    } catch (err) {
      commonToast("error", "Submission failed. Please try again.");
    }
  };

  const cleanupTransactionData = () => {
    handleDialogClose();
    loadData();
  };

  const handleReset = () => {
    const emptyRows = Array.from({ length: rows.length }, () => ({
      month: "",
      currency_code: "",
      exchange_rate: ""
    }));
    setRows(emptyRows);
    setSelectAll(false);
    setValidationStatus(Array.from({ length: rows.length }, () => true));
    setSelectedRows(selectedRows.fill(false));
  };
  const handleDownloadBtnClick = () => {
    setIsDownloadInProgress(true);
    try {
      instance
        .get(`${downloadExchangeRate}`, { responseType: "blob" })
        .then((response) => {
          const url = URL.createObjectURL(response.data);
          const link = document.createElement("a");
          link.href = url;
          const fileName = `ExchangeRate_${format(new Date(), "dd-MM-yyyy")}`
          link.setAttribute("download", `${fileName}.xlsx`);
          document.body.appendChild(link);
          link.click();
          link.parentNode.removeChild(link);
          setIsDownloadInProgress(false);
          commonToast("success", "Exchange Rate data has been downloaded successfully");
        }).catch((err) => {
          console.log(err);
          setIsDownloadInProgress(false);
          commonToast("error", "Exchange Rate data could not be downloaded");
        });
    } catch (error) {
      setIsDownloadInProgress(false);
      console.log(error);
      commonToast("error", "Exchange Rate data could not be downloaded");
    }
  }

  const handleEnter = (e) => {
    if (e.code === "Enter") {
      handleSearchBnkExchangeList();
    }
  };

  // const uploadFile = async (formData) => {
  //   try {
  //     const response = await instance.post(
  //       "documents/roe_file_upload/",
  //       formData,
  //       {
  //         headers: {
  //           "Content-Type": "multipart/form-data",
  //         },
  //       }
  //     );  
  //     if (response.status === 200) {

  //       toast.success("File uploaded successfully.", {
  //         position: toast.POSITION.TOP_RIGHT,
  //         autoClose: 1000,
  //       });
  //     }
  //   } catch (error) {
  //     toast.error(error?.data?.message || "File not uploaded!", {
  //       position: toast.POSITION.TOP_RIGHT,
  //       autoClose: 1000,
  //     });
  //   }
  //   setIsButtonDisabled(false);
  // };

  // const handleFileChange = (event) => {
  //   const file = event.target.files[0];
  //   if (!file) return;

  //   setIsButtonDisabled(true);

  //   const fileSizeLimit = 10485760;

  //   // Check if the file is an Excel file
  //   const validTypes = ['application/vnd.openxmlformats-officedocument.spreadsheetml.sheet', 'application/vnd.ms-excel', "text/csv"];
  //   if (!validTypes.includes(file.type)) {
  //     toast.error("Please upload a valid Excel file.", {
  //       position: toast.POSITION.TOP_RIGHT,
  //       autoClose: 1000,
  //     });
  //     setIsButtonDisabled(false);
  //     return;
  //   }

  //   // Check if the file size exceeds the limit
  //   if (file.size > fileSizeLimit) {
  //     toast.error("File size should be less than or equal to 10 MB.", {
  //       position: toast.POSITION.TOP_RIGHT,
  //       autoClose: 1000,
  //     });
  //     setIsButtonDisabled(false);
  //     return;
  //   }

  //   // Check if the file name length exceeds 256 characters
  //   if (file.name.length > 256) {
  //     toast.error("File name should be less than 256 characters.", {
  //       position: toast.POSITION.TOP_RIGHT,
  //       autoClose: 1000,
  //     });
  //     setIsButtonDisabled(false);
  //     return;
  //   }

  //   // Prepare FormData
  //   const formData = new FormData();
  //   formData.append("file", file);

  //   // You can add additional parameters here if needed
  //   // formData.append("paramName", paramValue);

  //   uploadFile(formData);
  // };

  return (
    <>
      <style>
        {`
          /* Override DataGrid column headers to blue theme */
          .MuiDataGrid-root .MuiDataGrid-columnHeaders {
            background-color: #f8f9fa !important;
            border-bottom: 2px solid #e0e0e0 !important;
          }
          .MuiDataGrid-root .MuiDataGrid-columnHeader {
            background-color: transparent !important;
            color: #1672DE !important;
          }
          /* Override DataGrid selection colors to blue - override MUI theme primary color */
          .MuiDataGrid-root .MuiDataGrid-row.Mui-selected,
          .MuiDataGrid-root .MuiDataGrid-row[aria-selected="true"] {
            background-color: rgba(22, 114, 222, 0.08) !important;
          }
          .MuiDataGrid-root .MuiDataGrid-row.Mui-selected:hover,
          .MuiDataGrid-root .MuiDataGrid-row[aria-selected="true"]:hover {
            background-color: rgba(22, 114, 222, 0.12) !important;
          }
          .MuiDataGrid-root .MuiDataGrid-row:hover {
            background-color: rgba(22, 114, 222, 0.04) !important;
          }
          /* Override any orange/yellow colors from theme */
          .MuiDataGrid-root .MuiDataGrid-columnHeaders[style*="#FF"],
          .MuiDataGrid-root .MuiDataGrid-columnHeader[style*="#FF"],
          .MuiDataGrid-root .MuiDataGrid-row.Mui-selected[style*="#FF"],
          .MuiDataGrid-root .MuiDataGrid-row.Mui-selected[style*="ff5"] {
            background-color: rgba(22, 114, 222, 0.08) !important;
          }
        `}
      </style>
      <div style={Container}>
        <CommonFilterSidebar
          isOpen={filterSidebarOpen}
          filterConfigs={[
            {
              type: "custom",
              content: (
                <Box>
                  <Typography
                    sx={{
                      fontSize: "16px",
                      fontWeight: "600",
                      color: "#000",
                      marginBottom: "12px",
                    }}
                  >
                    Currency Code
                  </Typography>
                  <Box onKeyUp={(e) => handleEnter(e)}>
                    <CommonSelect
                      handleChange={(event, value, reason) =>
                        handleCurrencyDropDown(
                          "Currency_Code",
                          value,
                          reason,
                          event
                        )
                      }
                      options={Array.isArray(dropdownValuesCurreny) ? dropdownValuesCurreny.map(
                        (option) => option?.currency_code
                      ).filter(Boolean) : []}
                      placeholder="Select Currency"
                      value={searchFieldPrams?.Currency_Code || ""}
                    />
                  </Box>
                  <Typography
                    sx={{
                      fontSize: "16px",
                      fontWeight: "600",
                      color: "#000",
                      marginBottom: "12px",
                      marginTop: "24px",
                    }}
                  >
                    Transaction Year
                  </Typography>
                  <TextField
                    fullWidth
                    size="small"
                    value={searchFieldPrams?.Transaction_Year}
                    onChange={(e) =>
                      handleTextFieldchange(
                        "Transaction_Year",
                        e.target.value
                      )
                    }
                    onKeyUp={(e) => handleEnter(e)}
                    placeholder="Enter Year"
                    sx={{
                      "& .MuiOutlinedInput-root": {
                        borderRadius: "4px",
                        "& fieldset": {
                          borderColor: "#d0d0d0",
                        },
                        "&:hover fieldset": {
                          borderColor: "#999",
                        },
                        "&.Mui-focused fieldset": {
                          borderColor: "#1672DE",
                        },
                      },
                    }}
                  />
                  <Typography
                    sx={{
                      fontSize: "16px",
                      fontWeight: "600",
                      color: "#000",
                      marginBottom: "12px",
                      marginTop: "24px",
                    }}
                  >
                    Transaction Month
                  </Typography>
                  <Box onKeyUp={(e) => handleEnter(e)}>
                    <CommonSelect
                      handleChange={(event, value, reason) => {
                        if (value && months[value]) {
                          const monthNumber = months[value];
                          handleTextFieldchange("Transaction_Month", monthNumber);
                        }
                      }}
                      options={Object.keys(months) || []}
                      placeholder="Select Month"
                      value={
                        searchFieldPrams?.Transaction_Month
                          ? Object.keys(months).find(
                            (key) => months[key] === searchFieldPrams?.Transaction_Month
                          ) || ""
                          : ""
                      }
                    />
                  </Box>
                </Box>
              ),
            },
          ]}
          onApplyFilters={handleApplyFilters}
          onClearFilters={handleClearFilters}
          isLoading={pageState?.isLoading}
          isFilterDisabled={isFilterBtnDisable()}
        />

        <Box className="main-content-area">
          <Box className="page-header-container">
            <Typography variant="h5" className="page-heading">
              Exchange Rate
            </Typography>
            <Box sx={{ display: "flex", alignItems: "center", gap: "10px" }}>
              {UserAuthorisation?.["Creation"] === "Y" && (
                <>
                  <CommonButton
                    text="Add"
                    handleClick={() => handleActionButton()}
                    sx={bankTransactionAddBtn}
                    hoverColor="#1565c0"
                  />
                  <CommonButton
                    text="Export"
                    handleClick={handleDownloadBtnClick}
                    sx={downloadBtn}
                    hoverColor="#1565c0"
                    disabled={isDownloadInProgress}
                  />
                </>
              )}
              <IconButton
                onClick={() => setFilterSidebarOpen(!filterSidebarOpen)}
                className="filter-toggle-button"
              >
                <FilterListIcon />
              </IconButton>
            </Box>
          </Box>

          <Box
            sx={{
              flex: 1,
              display: "flex",
              flexDirection: "column",
              minHeight: 0,
              position: "relative",
              backgroundColor: "#ffffff",
              borderRadius: "12px",
              boxShadow: "0 4px 16px rgba(0,0,0,0.08)",
              overflow: "hidden",
              transition: "all 0.3s ease",
              border: "1px solid #e8eaf0",
              "&:hover": {
                boxShadow: "0 6px 20px rgba(0,0,0,0.12)",
              },
            }}
          >
            <DataGrid
              className={classes.pagination}
              loading={pageState?.isLoading}
              rows={pageState?.data ?? []}
              columns={columns}
              rowCount={pageState?.total}
              // hideFooterPagination
              // hideFooter
              keepNonExistentRowsSelected
              disableSelectionOnClick
              pagination
              paginationMode="server"
              getRowId={(row) => row?.id}
              page={pageState.page - 1}
              pageSize={pageState?.pageSize ?? 25}
              onPageSizeChange={(newPageSize) => {
                setPageState((old) => {
                  setPaginationCount(getPaginationCount(pageState?.total, newPageSize))
                  return { ...old, pageSize: newPageSize, page: 1 };
                });
              }}
              rowsPerPageOptions={[10, 25, 50, 100]}
              components={{
                Toolbar: GridToolbarContainer,
                NoRowsOverlay: () => (
                  <Stack height="100%" alignItems="center" justifyContent="center">
                    No Exchange Rate Records
                  </Stack>
                ),
              }}
              sx={{
                border: "none",
                flex: 1,
                minHeight: 0,
                "& .MuiDataGrid-root": {
                  border: "none",
                  height: "100%",
                },
                "& .MuiDataGrid-main": {
                  height: "100%",
                  "&::-webkit-scrollbar": {
                    width: "8px",
                    height: "8px",
                  },
                  "&::-webkit-scrollbar-track": {
                    background: "#f1f1f1",
                    borderRadius: "10px",
                  },
                  "&::-webkit-scrollbar-thumb": {
                    background: "#1672DE",
                    borderRadius: "10px",
                    "&:hover": {
                      background: "#1565c0",
                    },
                  },
                },
                "& .MuiDataGrid-columnHeaders": {
                  backgroundColor: "#f8f9fa",
                  borderBottom: "2px solid #e0e0e0",
                  minHeight: "52px !important",
                  maxHeight: "52px !important",
                },
                "& .MuiDataGrid-columnHeader": {
                  backgroundColor: "transparent",
                  fontWeight: "600",
                  color: "#1672DE",
                  fontSize: "14px",
                  padding: "12px 16px",
                  borderBottom: "none",
                  "&:focus": {
                    outline: "none",
                  },
                  "&:focus-within": {
                    outline: "none",
                  },
                  "& .MuiDataGrid-columnHeaderTitle": {
                    fontWeight: "600",
                    fontSize: "14px",
                  },
                  "& .MuiDataGrid-sortIcon": {
                    color: "#1672DE",
                  },
                  "& .MuiDataGrid-menuIcon": {
                    color: "#1672DE",
                  },
                },
                "& .MuiDataGrid-columnHeader[data-field='actions']": {
                  minWidth: toggle?.isOpen ? "175px !important" : "203px !important",
                },
                "& .MuiDataGrid-row": {
                  transition: "all 0.2s ease",
                  borderBottom: "1px solid #f0f0f0",
                  "&:hover": {
                    backgroundColor: "rgba(22, 114, 222, 0.04)",
                    boxShadow: "0 2px 4px rgba(0,0,0,0.02)",
                  },
                  "&.Mui-selected": {
                    backgroundColor: "rgba(22, 114, 222, 0.08)",
                    "&:hover": {
                      backgroundColor: "rgba(22, 114, 222, 0.12)",
                    },
                  },
                  "&:nth-of-type(even)": {
                    backgroundColor: "#fafafa",
                    "&:hover": {
                      backgroundColor: "rgba(22, 114, 222, 0.04)",
                    },
                  },
                },
                "& .MuiDataGrid-cell": {
                  borderBottom: "1px solid #f0f0f0",
                  padding: "12px 16px",
                  fontSize: "13px",
                  color: "#333",
                  display: "flex",
                  alignItems: "center",
                  "&:focus": {
                    outline: "none",
                  },
                  "&:focus-within": {
                    outline: "none",
                  },
                },
                "& .MuiDataGrid-virtualScroller": {
                  "&::-webkit-scrollbar": {
                    width: "8px",
                    height: "8px",
                  },
                  "&::-webkit-scrollbar-track": {
                    background: "#f1f1f1",
                    borderRadius: "10px",
                  },
                  "&::-webkit-scrollbar-thumb": {
                    background: "#1672DE",
                    borderRadius: "10px",
                    "&:hover": {
                      background: "#1565c0",
                    },
                  },
                },
                "& .MuiDataGrid-footerContainer": {
                  borderTop: "2px solid #e0e0e0",
                  borderBottom: "none",
                  backgroundColor: "#f8f9fa",
                  minHeight: "56px",
                  maxHeight: "56px",
                  paddingBottom: "8px",
                  paddingTop: "8px",
                  paddingLeft: "16px",
                  paddingRight: "16px",
                  position: "relative",
                  zIndex: 1,
                  display: "flex",
                  alignItems: "center",
                  "& .MuiTablePagination-root": {
                    color: "#666",
                    paddingRight: "20px",
                    margin: 0,
                    minHeight: "32px",
                  },
                  "& .MuiTablePagination-selectLabel": {
                    fontSize: "13px",
                    margin: 0,
                  },
                  "& .MuiTablePagination-actions": {
                    display: "none", // Hide default pagination actions to properly align custom ones
                  },
                  "& .MuiTablePagination-displayedRows": {
                    marginRight: "250px", // Increased right margin to separate from absolute positioned custom paginator
                  }
                },
              }}
            />
            <Stack
              sx={{
                position: "absolute",
                bottom: "13px",
                right: "24px",
                zIndex: 2,
                display: "flex",
                alignItems: "center",
              }}
            >
              <CommonPaginationContainer
                count={paginationCount + 1}
                pageState={pageState}
                setPageState={setPageState}
              />
            </Stack>
          </Box>
        </Box>
      </div>

      {/* <MyComponent /> */}

      <Dialog
        open={EntityDialog}
        disableBackdropClick
        disableEscapeKeyDown
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        fullWidth
        PaperProps={{
          sx: {
            borderRadius: "12px",
            boxShadow: "0 8px 32px rgba(22, 114, 222, 0.15)",
            overflow: "hidden",
          },
        }}
        sx={{
          "& .MuiDialog-paper": {
            borderRadius: "12px",
            overflow: "hidden",
          },
        }}
      >
        <DialogTitle
          sx={{
            backgroundColor: "#1672DE",
            color: "white",
            padding: "20px 24px",
            fontWeight: "600",
            fontSize: "20px",
            margin: 0,
          }}
        >
          {viewMode ? "View Exchange Rate" : editMode ? "Edit Exchange Rate" : "Add Exchange Rate"}
          <IconButton
            aria-label="close"
            onClick={handleDialogClose}
            sx={{
              position: "absolute",
              right: 12,
              top: 12,
              color: "white",
              transition: "all 0.2s ease",
              "&:hover": {
                color: "#ffffff",
                backgroundColor: "rgba(255, 255, 255, 0.1)",
              },
            }}
          >
            <CloseIcon />
          </IconButton>
        </DialogTitle>
        <DialogContent
          sx={{ overflowX: "hidden", padding: "24px", backgroundColor: "#ffffff" }}
        >
          <div elevation={4} style={EditPageContainerTransactions}>
            {!editMode && !viewMode && (
              <div style={EditPageContainerTransactionsList}>
                <div
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    gap: "10px",
                  }}
                >
                  <CommonButton
                    text="Add"
                    handleClick={handleAddRow}
                    icon={<AddIcon sx={{ ml: 0.5 }} />}
                    hoverColor="#1565c0"
                    sx={{
                      backgroundColor: "#1672DE",
                      color: "white",
                      borderRadius: "10px",
                      padding: "8px 16px",
                      fontWeight: "600",
                      fontSize: "14px",
                      textTransform: "none",
                      minHeight: "36px",
                      boxShadow: "0 2px 8px rgba(22, 114, 222, 0.2)",
                      "&:hover": {
                        boxShadow: "0 4px 12px rgba(22, 114, 222, 0.3)",
                        transform: "translateY(-1px)",
                      },
                    }}
                  />
                  <CommonButton
                    text="Delete"
                    handleClick={handleDeleteRow}
                    disabled={selectedRows.filter(Boolean).length === 0}
                    icon={<DeleteIcon sx={{ ml: 0.5 }} />}
                    hoverColor="rgba(244, 67, 54, 0.1)"
                    sx={{
                      backgroundColor: "transparent",
                      color: "#f44336",
                      border: "1px solid #f44336",
                      borderRadius: "10px",
                      padding: "8px 16px",
                      fontWeight: "600",
                      fontSize: "14px",
                      textTransform: "none",
                      minHeight: "36px",
                      "&:hover": {
                        backgroundColor: "rgba(244, 67, 54, 0.05)",
                        borderColor: "#d32f2f",
                        color: "#d32f2f",
                      },
                      "&:disabled": {
                        backgroundColor: "transparent",
                        color: "rgba(0, 0, 0, 0.26)",
                        borderColor: "#e0e0e0",
                      },
                    }}
                  />
                </div>
              </div>
            )}
            {isCreated ? (
              <TableContainer style={{ maxHeight: "300px" }}>
                <AddBankExchange
                  selectAll={selectAll}
                  handleInputChange={handleInputChange}
                  handleSelectAll={handleSelectAll}
                  rows={rows}
                  // handleBlur={handleBlur}
                  handleCheckboxChange={handleCheckboxChange}
                  validationStatus={validationStatus}
                  selectedRows={selectedRows}
                />
              </TableContainer>
            ) : (
              <>
                {rows?.map((row, index) => (
                  <Grid display={"flex"} flexDirection={"column"}>
                    <ViewAndEditEntity
                      row={row}
                      index={index}
                      viewMode={viewMode}
                      validationStatus={validationStatus}
                      editMode={editMode}
                      handleInputChange={handleInputChange}
                    />
                  </Grid>
                ))}
              </>
            )}
          </div>
        </DialogContent>

        <DialogActions
          sx={{
            backgroundColor: "#ffffff",
            padding: "16px 24px",
            borderTop: "1px solid #e0e0e0",
            gap: "12px",
            justifyContent: "flex-end",
          }}
        >
          {viewMode ? null : (
            <>
              {isCreated && (
                <CommonButton
                  text="Reset"
                  handleClick={() => handleReset()}
                  disabled={editMode}
                  hoverColor="rgba(22, 114, 222, 0.05)"
                  sx={{
                    backgroundColor: "transparent",
                    color: "#1672DE",
                    border: "1px solid #1672DE",
                    borderRadius: "10px",
                    padding: "10px 24px",
                    fontWeight: "600",
                    fontSize: "14px",
                    textTransform: "none",
                    minHeight: "40px",
                    minWidth: "120px",
                    "&:hover": {
                      backgroundColor: "rgba(22, 114, 222, 0.05)",
                      borderColor: "#1565c0",
                      color: "#1565c0",
                    },
                    "&:disabled": {
                      backgroundColor: "transparent",
                      color: "rgba(0, 0, 0, 0.26)",
                      borderColor: "#e0e0e0",
                    },
                  }}
                />
              )}
              {editMode && (
                <CommonButton
                  text="Update"
                  handleClick={handleSubmit}
                  disabled={Object.keys(currentUpdatedFiledsInEditMode)?.length <= 0}
                  hoverColor="#1565c0"
                  sx={{
                    backgroundColor: "#1672DE",
                    color: "white",
                    borderRadius: "10px",
                    padding: "10px 24px",
                    fontWeight: "600",
                    fontSize: "14px",
                    textTransform: "none",
                    minHeight: "40px",
                    minWidth: "120px",
                    boxShadow: "0 4px 16px rgba(22, 114, 222, 0.3)",
                    "&:hover": {
                      backgroundColor: "#1565c0",
                      boxShadow: "0 6px 24px rgba(22, 114, 222, 0.4)",
                      transform: "translateY(-1px)",
                    },
                    "&:disabled": {
                      backgroundColor: "#e0e0e0",
                      color: "#9e9e9e",
                      boxShadow: "none",
                      transform: "none",
                    },
                  }}
                />
              )}
              {!editMode && !viewMode && (
                <CommonButton
                  text="Submit"
                  handleClick={handleSubmit}
                  hoverColor="#1565c0"
                  sx={{
                    backgroundColor: "#1672DE",
                    color: "white",
                    borderRadius: "10px",
                    padding: "10px 24px",
                    fontWeight: "600",
                    fontSize: "14px",
                    textTransform: "none",
                    minHeight: "40px",
                    minWidth: "120px",
                    boxShadow: "0 4px 16px rgba(22, 114, 222, 0.3)",
                    "&:hover": {
                      backgroundColor: "#1565c0",
                      boxShadow: "0 6px 24px rgba(22, 114, 222, 0.4)",
                      transform: "translateY(-1px)",
                    },
                    "&:disabled": {
                      backgroundColor: "#e0e0e0",
                      color: "#9e9e9e",
                      boxShadow: "none",
                      transform: "none",
                    },
                  }}
                />
              )}
            </>
          )}
        </DialogActions>
      </Dialog>
    </>
  );
}

// Add error boundary check
if (typeof window !== 'undefined') {
  window.BankExchangeRateError = null;
}
